/**
 * グローバル変数のWindowにgtag用の型定義を追加する
 */
declare global {
  interface Window {
    dataLayer: Array<any>
  }
}

export const fireGtmEvent = (eventKey: string, value: string) => {
  if (!window.dataLayer) return
  window.dataLayer.push({
    event: eventKey,
    select_sort_variable: value,
  })
}
